<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: ['mostrar', 'id', 'salvando', 'numero'],
    data() {
      return {
        confirmando: false,
      }
    },
    methods: {
      confirmar() {
        this.confirmando = true;
      }
    },
    computed: {
      show() {        
        this.confirmando = false;
        return this.mostrar;
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           :backdrop="!salvando">
      <div slot="modal-header" class="modal-header hide"></div>

      <div class="swal2-icon swal2-question" style="display: block;">?</div>

      <h3 class="text-center" v-if="!confirmando">
        Deseja liberar o relat&oacute;rio t&eacute;cnico {{ numero || '' }}?
      </h3>

      <div slot="modal-footer" class="modal-footer" v-if="!confirmando">
        <button type="button" class="btn btn-primary" :disabled="salvando" style="margin-bottom: 5px;" @click="$emit('liberar')">
          <i class="fa fa-check"></i> Liberar
        </button>

        <button type="button" class="btn btn-default" style="margin-bottom: 5px;" @click="$refs.modal.action(false, 3)" :disabled="salvando">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>

      <div slot="modal-footer" class="modal-footer" v-if="confirmando">
        <button type="button" class="btn btn-primary" :disabled="salvando" style="margin-bottom: 5px;" @click="$emit('liberar')">
          <i class="fa fa-check"></i> Confirmar
        </button>
        <button type="button" class="btn btn-default" style="margin-bottom: 5px;" @click="$refs.modal.action(false, 3)" :disabled="salvando">
          <i class="fa fa-times"></i> Cancelar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalLiberarRelatorioTecnicoProjeto.vue